var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "600"
    },
    on: {
      "click:outside": function ($event) {
        return _vm.$emit('onClose');
      }
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin d-flex flex-column",
    staticStyle: {
      "max-height": "90vh"
    }
  }, [_c('v-card-text', {
    staticClass: "pa-4 flex-grow-1",
    staticStyle: {
      "overflow-y": "hidden"
    }
  }, [_c('v-row', {
    staticClass: "d-flex justify-center"
  }, [_c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "error",
      "size": "64"
    }
  }, [_vm._v("mdi-alert-circle")]), _c('div', {
    staticClass: "text-subtitle-1 font-weight-bold mt-2"
  }, [_vm._v(" O registro selecionado está em uso nos seguintes lugares: ")])], 1)], 1), _c('v-row', {
    staticClass: "flex-grow-1",
    staticStyle: {
      "min-height": "0"
    }
  }, [_c('v-col', {
    staticClass: "d-flex flex-column",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "cols": "12"
    }
  }, [_c('v-list', {
    staticClass: "flex-grow-1",
    staticStyle: {
      "overflow-y": "auto"
    }
  }, [_vm._l(_vm.paginatedItems, function (item, index) {
    return _c('v-list-item', {
      key: index
    }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item))])], 1)], 1);
  }), _vm.paginatedItems.length === 0 ? _c('div', {
    staticClass: "text-center py-4"
  }, [_vm._v(" Nenhum registro encontrado ")]) : _vm._e()], 2), _c('div', {
    staticClass: "text-center pt-2"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount,
      "circle": "",
      "total-visible": 7
    },
    model: {
      value: _vm.page,
      callback: function ($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "footer-area pt-2"
  }, [_c('v-divider'), _c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    staticClass: "text-center py-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "text-subtitle-1"
  }, [_vm._v(" Total de ocorrências: " + _vm._s(_vm.locaisDeUso.length) + " ")])])], 1), _c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    staticClass: "text-center pb-4",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  }, [_vm._v(" Fechar ")])], 1)], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }